module.exports = __webpack_public_path__ + "static/media/camp-patates-vell-4.d005983a.jpg";